export const SLA_CHAINS_TYPE = 'slaChains';
